import React, { useCallback } from 'react';
import { Message } from 'src/core/engine/types';
import { MessagesModal } from 'src/components/Modal/MessagesModal';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { AppMsg } from 'src/features/app/app.actions';
import { StoreState } from 'src/types/global-types';

type Props = {
    close(): void;
    messages: Message[];
    title: string;
};

export const AppMessageModal: React.FC<Props> = (props) => {
    return <MessagesModal {...props} />;
};

const selector = (s: StoreState) => s.app.messages;

export const AppMessageConnected: React.FC = () => {
    const messages = useSelector(selector, shallowEqual);
    const dispatch = useDispatch();
    const close = useCallback(() => {
        dispatch(AppMsg('App.ClearMessages'));
    }, [dispatch]);

    if (messages.length === 0) {
        return null;
    }

    return <AppMessageModal close={close} title="A problem occurred" messages={messages} />;
};
